const allowSubmission = (
  FormStatus,
  FormTypeAvailable,
  VisitedAllPages,
  IsDeveloper,
  IsTester
) => {
  let allow_submission = VisitedAllPages;
  if (
    (FormStatus &&
      ((FormTypeAvailable && VisitedAllPages) ||
        (IsDeveloper && VisitedAllPages))) ||
    IsTester
  ) {
    allow_submission = true;
  } else {
    allow_submission = false;
  }

  return allow_submission;
};

export default allowSubmission;
